import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';

import { initProcessSelect, patternPage } from '../common/Common';
import ProcessPatternForm from '../parameter/parent/processPattern/ProcessPatternForm';
import { getDeviceInfo, getProcessInfo, updateUserSetting } from '../common/CommonAPI';
import { CreatePMXData, ProcessDetailGroup, ServiceClass } from '../common/enums';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import { ParentClassNumber } from '../common/Constant';

const ParentKouteiSentaku = forwardRef((props, ref) => {
  const [listData, setListData] = useState([]);
  const [processSelectedData, setProcessSelectedData] = useState([]);
  const [kouteiSentakuPatternNo, setKouteiSentakuPatternNo] = useState(0);
  const [kouteiSentakuPatternList, setKouteiSentakuPatternList] = useState([]);
  const [deviceMasterInfo, setDeviceMasterInfo] = useState([]);
  const [processMasterInfo, setProcessMasterInfo] = useState([]);
  const [clientInfo, setClientInfo] = useState([]);

  const patternformRef = useRef();

  // useEffect(() => {
  //   if (props?.activeTabKey === '2' || props?.pmxMode) {
  //     await getProcesssPatternInfo();
  //   }
  // }, [props.activeTabKey, props?.isReCal]);

  // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
  useEffect(() => {
    const fetchProcessPatternInfo = async () => {
      if (props?.activeTabKey === '2' || props?.pmxMode) {
        await getProcesssPatternInfo();
      }
    };

    fetchProcessPatternInfo();
  }, [props.activeTabKey, props?.isReCa, props.selectedDataDetail]);

  const getProcesssPatternInfo = async () => {
    let kouteiPatternList = [];
    let parameters = props.selectedDataDetail?.estimateProducts?.calcParameters?.parameters;
    // 工程マスタデータ
    const patternLst = parameters?.processPattern;
    kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.Parent);

    setListData(kouteiPatternList);
    setKouteiSentakuPatternList(kouteiPatternList);
    let processSelect = props?.selectedDataDetail?.estimateProducts?.processSelect;
    // //初期状態に金額を０にしてほしい対応
    // if (processSelect.id === undefined) {
    //   let initProcessSelect = {
    //     id: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.id : 0,
    //     name: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.name : '',
    //     details: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.details : [],
    //     modified: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.modified : dayjs().format(),
    //   };
    //   processSelect = initProcessSelect;
    // }

    // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
    if (!processSelect) {
      processSelect = {
        id: 0,
        name: '',
        details: [], // empty array to avoid .details undefined error
        modified: dayjs().format(),
      };
    }
    if (props.type !== 'pmx') {
      if (!Array.isArray(processSelect?.details) || processSelect.details.length <= 0) {
        const currentServiceClass = getCurrentServiceClass();
        const defaultPatternList = await getDefaultProcessPattern(currentServiceClass);
        processSelect.details = defaultPatternList;
      }
    } else {
      let estimateProducts = props?.selectedDataDetail?.estimateProducts;
      processSelect = estimateProducts ? estimateProducts?.processSelect : processSelect;
      if (processSelect) {
        setProcessSelectedData(processSelect);
        setKouteiSentakuPatternNo(processSelect.id);
      }
      if (!Array.isArray(processSelect?.details) || processSelect.details.length <= 0) {
        const defaultPatternList = await getDefaultProcessPattern(ParentClassNumber);

        processSelect.details = defaultPatternList;
      }
    }
    setProcessSelectedData(processSelect);
    setKouteiSentakuPatternNo(processSelect?.id);
    setDeviceMasterInfo(parameters?.device);
    setProcessMasterInfo(parameters?.process);
    setClientInfo(parameters?.client);
  };

  const updateKouteiSentakuInfo = async (selectedProcessPattern, list) => {
    setKouteiSentakuPatternNo(selectedProcessPattern.id);
    setProcessSelectedData(selectedProcessPattern);
    setKouteiSentakuPatternList(list);
    props.selectedDataDetail.estimateProducts.processSelect = initProcessSelect(selectedProcessPattern);

    if (props?.type === 'pmx' && props?.isNewPMXOrNot === CreatePMXData.New) {
      props.updateSelectedParentPatternNo(selectedProcessPattern?.id);
    } else {
      // IQX_WEBEST-323 新規処理の前回値の採用
      let userSetting = props.selectedDataDetail.estimateProducts.calcParameters.settings.userSettings;
      if (userSetting?.length > 0) userSetting = userSetting[0];
      if (userSetting !== null) {
        if (userSetting.users?.newParentInitialInfo?.parentProcessPatternId !== undefined) {
          userSetting.users.newParentInitialInfo.parentProcessPatternId = selectedProcessPattern.id;
          await updateUserSetting(userSetting, 0);
        }
      }
    }

    // props.updatePatternList(updatePatternList)
  };

  // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
  const getDefaultProcessPattern = async (currentServiceClass) => {
    let processMasterData = [];
    let processList = [];
    let deviceList = [];
    let multiProcessList = [];
    const processMaster = await getProcessInfo(); // 工程マスタデータ
    const deviceMasterInfo = await getDeviceInfo(0, 0, currentServiceClass, 'ASC', 'id', {}); // 装置マスタデータ
    let deviceMaster = [];
    if (deviceMasterInfo) {
      deviceMaster = deviceMasterInfo?.data;
    }

    //工程マスターデータにより種類選択ボックスデータ準備
    if (currentServiceClass === ServiceClass.Parent) {
      // 親部品の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.Parent);
    } else if (currentServiceClass === ServiceClass.SheetMetal) {
      // 板金の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.SheetMetal);
    } else if (currentServiceClass === ServiceClass.Beams) {
      // 形鋼の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.Beams);
    }
    deviceList = deviceMaster?.filter((item) => processMasterData?.filter((process) => process?.id == item?.processId));
    if (deviceList !== null && processMasterData !== null) {
      processMasterData?.forEach((master) => {
        if (master.isAdditional) {
          // 追加タイプの場合、
          let processDetailTypes = master.details?.processDetailTypes;
          for (let j = 0; j < processDetailTypes?.length; j++) {
            // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
            let device = deviceList
              ?.filter((item) => item.processId === master.id && item?.info?.isUsed === true)
              ?.filter((device) => device?.details?.addProcessTypeId === processDetailTypes[j]?.id);

            multiProcessList = [];
            multiProcessList.push({
              processNo: 1,
              processDetailGroup: ProcessDetailGroup.None,
              processDetailTypeId: processDetailTypes[j]?.id,
            });
            processList.push({
              processId: master?.id,
              deviceId: device?.length > 0 ? device?.[0].id : 0,
              isUsedForCalc: false,
              multiprocesses: multiProcessList,
            });
          }
        } else {
          // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
          let device = deviceList?.filter((item) => item.processId == master.id && item?.info?.isUsed === true)?.[0];
          multiProcessList = [];
          for (let i = 1; i <= master?.details?.processQty; i++) {
            multiProcessList.push({
              processNo: i,
              processDetailGroup: ProcessDetailGroup.None,
              processDetailTypeId: 0,
            });
          }
          processList.push({
            processId: master?.id,
            deviceId: device?.id ? device?.id : 0, // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
            isUsedForCalc: false,
            multiprocesses: multiProcessList,
          });
        }
      });
    }

    return processList;
  };

  const updateIsPrepareInfoFlg = (flg) => {
    props?.updateIsPrepareInfoFlg(flg);
  };

  useImperativeHandle(
    ref,
    () => ({
      getKouteiSentakuPatternNo: () => {
        return kouteiSentakuPatternNo;
      },
      getProcessSelectedData: () => {
        return processSelectedData;
      },
      getKouteiSentakuPatternList: () => {
        return kouteiSentakuPatternList;
      },
    }),
    [kouteiSentakuPatternNo, processSelectedData, kouteiSentakuPatternList]
  );

  // 工程パターンのルートパスで「親部品／板金」の判断
  const getCurrentServiceClass = () => {
    const currentRoute = location.pathname;
    if (currentRoute?.includes('parent')) {
      return ServiceClass.Parent;
    } else if (currentRoute?.includes('iq3')) {
      return ServiceClass.SheetMetal;
    } else if (currentRoute?.includes('iq5')) {
      return ServiceClass.Beams;
    }
  };

  // 見積データ画面から工程パターン登録
  const updatePatternList = (data) => {
    setListData(data);

    // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
    const classVal = ParentClassNumber;

    const parameters = props?.selectedDataDetail?.estimateProducts?.calcParameters?.parameters;

    if (parameters) {
      const existingList = parameters.processPattern || [];

      const preservedList = existingList.filter((item) => item.class !== classVal);

      const updatedClass0 = data.filter((item) => item.class === classVal);

      const mergedProcessPattern = [...preservedList, ...updatedClass0];

      parameters.processPattern = mergedProcessPattern;
      props.selectedDataDetail.estimateProducts.calcParameters.parameters = {
        ...parameters,
        processPattern: mergedProcessPattern,
      };
    }
  };

  return (
    <Spin spinning={props?.activeTabKey === '2' || props?.pmxMode ? false : true} tip="" size="large">
      <>
        {/* 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。 */}
        {/* {props?.activeTabKey === '2' || props?.pmxMode ? ( */}
        {(props?.activeTabKey === '2' || props?.pmxMode) &&
          processSelectedData &&
          Array.isArray(processSelectedData.details) &&
          processSelectedData.details.length > 0 && (
            <ProcessPatternForm
              ref={patternformRef}
              selectedData={processSelectedData}
              listData={listData}
              editMode={props?.editMode}
              page={patternPage[0]}
              isParameter={false}
              updateKouteiSentakuInfo={updateKouteiSentakuInfo}
              kouteiSentakuEditMode={props?.editMode}
              pmxMode={props.pmxMode}
              processMasterData={processMasterInfo}
              deviceMasterData={deviceMasterInfo}
              clientMasterData={clientInfo}
              updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
              updatePatternList={updatePatternList}
              patternInsertClass={props?.patternInsertClass}
              setPatternList={props?.setPatternList}
            />
          )}
      </>
    </Spin>
  );
});

export default ParentKouteiSentaku;
